// extracted by mini-css-extract-plugin
export default {"formContainer":"belief-editor_formContainer__-ZfqN"};